import React, { FC, useState } from 'react';

import {
    AppTemplate
} from '@components/4-templates';

import {
    IconButton
} from '@components/2-molecules';

import Add from '@assets/icons/plus';

import {
    DocumentList, DocumentsMenu,
} from '@components/3-organisms';


import { ForwardedPageProps } from '@lib/constants';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { STATE } from '@lib/constants';
import { useDocuments } from '@lib/hooks/useDocument';
import Sandwich from '@assets/icons/sandwich';
import {
  PageHeader
} from '@components/2-molecules';
import { useBusinessCountryCurrency } from '@lib/hooks/useBusiness';


const Documents: FC<ForwardedPageProps> = ({ navigation, data = {}, ...props }) => {

    const [documents,] = useDocuments({ state: STATE.READY });
    const [currency,] = useBusinessCountryCurrency();

    return (
        <AppTemplate  hooks={[documents]}>
        
            <PageHeader title={"DOCUMENTS"}
              left={<IconButton transparent icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
              menu={<DocumentsMenu navigation={navigation} />}
              menuIcon={<Add />}
            />
            
            <DocumentList
                currency={currency?.data?.symbol}
                color={documents?.data?.length ? '#000' : '#FFF'}
                data={documents?.data}
                onPress={ (data:any) => navigation.navigate( 'DocumentView', {data: data}) }
            />
        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(Documents);